/** Versioned definitions pin wording, choices and relationship meaning on each answer. */
export const storeKnowledgeQuestions = [
    {
        key: 'item_use',
        version: 1,
        text: 'How do you use this item?',
        predicate: 'item_use',
        purpose: 'Identify the merchant-stated use in an explicit context',
        options: [
            { value: 'sample', label: 'Sample' },
            { value: 'gift', label: 'Gift' },
            { value: 'packaging', label: 'Packaging' },
            { value: 'replacement', label: 'Replacement' },
            { value: 'retail', label: 'Retail product' },
            { value: 'other', label: 'Other' },
        ],
    },
    {
        key: 'sample_promotes_product',
        version: 1,
        text: 'Which retail products is this sample intended to encourage people to buy?',
        predicate: 'promotes_product',
        purpose: 'Record intended retail purchases, without asserting formulation or shopper perception',
        options: [
            { value: 'selected', label: 'Choose retail products' },
            { value: 'none', label: 'No specific retail product' },
            { value: 'unknown', label: 'I’m not sure yet' },
        ],
    },
];
export const knowledgeCandidateRule = { key: 'sample-candidate', version: 1 };
/** Facts explaining a nomination; none establishes the item's role. */
export function knowledgeCandidateClues(item) {
    const clues = [];
    const token = /(^|[^a-z])(sample|trial|tester)([^a-z]|$)/i;
    for (const field of ['title', 'productTitle', 'productType'])
        if (item[field] && token.test(item[field]))
            clues.push({ field, value: item[field] });
    for (const tag of item.tags)
        if (token.test(tag))
            clues.push({ field: 'tags', value: tag });
    if (item.freeOrders > 0)
        clues.push({ field: 'freeOrders', value: String(item.freeOrders) });
    return clues;
}
export const sampleCheckQuestions = [
    {
        key: 'item_is_sample',
        version: 1,
        text: 'Is this a sample?',
        predicate: 'item_is_sample',
        purpose: 'Confirm sample identity without classifying every order',
        options: [
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' },
            { value: 'not_sure', label: 'Not sure' },
        ],
    },
    {
        key: 'sample_promotes_product',
        version: 2,
        text: 'Which product does it promote?',
        predicate: 'promotes_product',
        purpose: 'Confirm intended retail purchase',
        options: [
            { value: 'selected', label: 'This product' },
            { value: 'unknown', label: 'Not sure' },
        ],
    },
];
//# sourceMappingURL=store-knowledge-questions.js.map